export const documentLabelPanelAction = (param) => {
  return (dispatch) => {
    dispatch({ type: "SET_DOCUMENTLABELPANELACTION", data: param });
  }
};